import React from "react";
import { Card } from "primereact/card";
import { ProgressBar } from "primereact/progressbar";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";

export default function XmotProduct({
  moreThanOneItem = false,
  xmotProduct,
  handleCreateSurvey,
}) {
  const recruitItems = [
    { title: "Custom Recruit 1", subtitle: "All-purpose cleaning spray" },
    { title: "Custom Recruit 2", subtitle: "All-purpose cleaning spray" },
  ];

  return (
    <div className="p-3 text-start">
      <h5 className="text_dark fw-600 mb-3">{xmotProduct?.category_name}</h5>
      <h6 className="fw-semibold">Credits</h6>

      {xmotProduct?.custom_recruits?.map((item, index) => (
        <div className="row mt-4" key={index}>
          {/* LEFT SIDE TEXT */}
          <div
            className={`col-md-${moreThanOneItem ? 12 : 6} pe-5 d-flex justify-content-between`}
          >
            <div>
              <div className="fw-semibold mb-1 title">{item.recruit_name}</div>
              <div className="text-muted fw-semibold mb-3">
                {item?.product_name}
              </div>
            </div>
            <div>
              <div className="mb-0 fw-semibold title">#:</div>
              <div className="text-muted fw-semibold">
                n = {item?.recruit_value}
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div
            className={`col-md-${moreThanOneItem ? 12 : 6} ${moreThanOneItem ? "mx-3" : "px-4"} d-flex align-items-center`}
            style={{
              borderLeft: "1px solid #ccc",
            }}
          >
            <h6 className="text_dark fw-600 fw-bold">
              XMOT <br /> Credits
            </h6>

            <div className="d-flex align-items-center mx-3 w-100">
              <div className="w-100">
                <div className="d-flex align-items-center">
                  <div
                    className="d-flex align-items-end justify-content-end pe-3 pb-1"
                    style={{
                      width: "180px",
                      borderRight: "2px solid #e5e5e5",
                    }}
                  >
                    <div className="fs-14 title me-1">Total</div>
                    <div
                      className="badge"
                      style={{
                        minWidth: "50px",
                        backgroundColor: "#cfcdcd",
                        color: "#002133",
                      }}
                    >
                      {item?.xmot_credits}
                    </div>
                  </div>

                  <div className="flex-grow-1 ps-3">
                    <ProgressBar
                      value={(item?.xmot_credits / 1000) * 100}
                      color="#7B1FA2"
                      showValue={false}
                      style={{ height: "12px", borderRadius: "10px" }}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <div
                    className="d-flex align-items-end justify-content-end pe-3 pb-1"
                    style={{
                      width: "180px",
                      borderRight: "2px solid #e5e5e5",
                    }}
                  >
                    <div className="fs-14 title me-1">Used</div>
                    <div
                      className="badge"
                      style={{
                        minWidth: "50px",
                        backgroundColor: "#cfcdcd",
                        color: "#002133",
                      }}
                    >
                      {item?.used_credits}
                    </div>
                  </div>

                  <div className="flex-grow-1 ps-3">
                    <ProgressBar
                      value={(item?.used_credits / 1000) * 100}
                      color="#f6ad32"
                      showValue={false}
                      style={{ height: "12px", borderRadius: "10px" }}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <div
                    className="d-flex align-items-end justify-content-end pe-3"
                    style={{
                      width: "180px",
                      borderRight: "2px solid #e5e5e5",
                    }}
                  >
                    <div className="fs-14 title me-1">Balance</div>
                    <div
                      className="badge"
                      style={{
                        minWidth: "50px",
                        backgroundColor: "#cfcdcd",
                        color: "#002133",
                      }}
                    >
                      {item?.xmot_credits - item?.used_credits}
                    </div>
                  </div>

                  <div className="flex-grow-1 ps-3">
                    <ProgressBar
                      value={
                        ((item?.xmot_credits - item?.used_credits) / 1000) * 100
                      }
                      color="#2b9cff"
                      showValue={false}
                      style={{ height: "12px", borderRadius: "10px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <Divider />
          </div>
        </div>
      ))}
      <Button
        label="Create a Custom XMOT"
        className="px-3 py-2 fw-bold createClientBtn mt-3"
        onClick={handleCreateSurvey}
      />
    </div>
  );
}
